<template>
    <vueVimeoPlayer class="VimeoPlayer" ref="player" :video-id="videoUrl" :player-height="height" @ready="onReady" @ended="onEnded"/>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player'

export default {
    components: {
        vueVimeoPlayer
    },
    name : "VimeoPlayer",
    props: {
        width: { type:Number, default:480 },
        height: { type:Number, default:320 },
        autoplay: { type:Number, default:1, validator: (v) => Number(v)===0||Number(v)===1 },
        videoUrl : { type:String, required:true },
        loop : { type:Number, default:1, validator: (v) => Number(v)===0||Number(v)===1 }
    },
    data() {
        return {
            ready : 0,
            isOpened: false
        }
    },
    methods: {
        onEnded() {
            this.$emit('ended')
        },
		onReady() {
			this.playerReady = true
		},
		play () {
			if (this.$refs.player) this.$refs.player.play()
		},
		pause () {
			if (this.$refs.player) this.$refs.player.pause()
		}
	},
    beforeUnmount() {
        this.$refs.player.pause()
    }
}
</script>

<style lang="stylus" scoped>
.VimeoPlayer
    width 100%
    height auto
    >>> iframe
        width 100%
        height 60vh
</style>